// ThreadView barrel — IFrameViewer (iframe 모드) 와 InnerViewer (host React
// 트리 직접 마운트) 중 하나를 vars.ts 의 useInnerViewer toggle + mobile 가드로
// 분기 선택해 default 로 export.
//
// OMD-237 결정 — desktop 기본을 IFrameViewer 로 전환 (대용량 메일 host DOM 노드
// 폭증 완화). InnerViewer 는 제거하지 않고 롤백 경로로 유지:
//   forceIFrame = isMobileApp() || isForcedIFrameViewer()
//   useInner    = !forceIFrame && (useInnerViewer || isForcedInnerViewer())
//   default     = useInner ? InnerViewer : IFrameViewer
//
// - mobile WebView (OfficeMail native app, user-agent 검사) 에서는 toggle 값과
//   무관하게 IFrameViewer 강제. mobile native bridge 가 iframe contentWindow 에
//   의존하므로 분리. (`forceIFrame` 이 항상 우선)
// - desktop browser 는 useInnerViewer = false (OMD-237) → IFrameViewer 기본.
// - runtime escape hatch (rebuild / redeploy 없이 사용자 단위 전환):
//   · `__forceIFrameViewer = 'true'` → IFrameViewer 강제 (mobile 과 동일 취급, 최우선).
//   · `__forceInnerViewer  = 'true'` → desktop 에서 InnerViewer 강제 (롤백). 단 mobile /
//     __forceIFrameViewer 가 설정되면 iframe 이 우선한다.
import { useInnerViewer } from 'vars'
import IFrameViewerDefault from './IFrameViewer'
import InnerViewerDefault from './InnerViewer'
import { ThreadView as IFrameViewerClass } from './IFrameViewer'
import { InnerViewer as InnerViewerClass } from './InnerViewer'
import { isMobileApp, isForcedIFrameViewer, isForcedInnerViewer } from './branchHelpers'

// viewerExt 의 `reactObj: ThreadView` type annotation 이 IFrameViewer 의 클래스
// instance 뿐 아니라 InnerViewer 의 instance 도 받을 수 있도록 union type 으로
// re-export. structural 으로는 두 클래스가 createEmailInfo / applyThread / onReady
// 등 viewerExt 가 사용하는 모든 메서드를 공유한다.
export type ThreadView = IFrameViewerClass | InnerViewerClass

// 분기 helper (`isMobileApp` / `isForcedIFrameViewer` / `isForcedInnerViewer`) 는
// [./branchHelpers.ts](./branchHelpers.ts) 로 분리 — 단위 테스트 시 IFrameViewer/InnerViewer
// 의 transitive 의존 (DataManager / popups 등) 을 회피한다.

const forceIFrame = isMobileApp() || isForcedIFrameViewer()
const useInner = !forceIFrame && (useInnerViewer || isForcedInnerViewer())

const ThreadView = useInner ? InnerViewerDefault : IFrameViewerDefault

export default ThreadView
